import React, { Component } from 'react';
import styles from './project-hero-wrapper.module.css';

class ProjectHeroWrapper extends Component {
  render() {
    const { browserDetect, headerHeight } = this.props;

    const renderIOSHeight =
      browserDetect === 'iOS' ? 'calc(100vh - 74px)' : '100vh';
    return (
      <div
        className={styles.wrapper}
        style={
          typeof headerHeight !== 'undefined'
            ? {
                height: `calc(100% - ${headerHeight}px)`,
                position: 'absolute',
                bottom: 0,
                left: 0,
                right: 0,
              }
            : {
                position: 'relative',
                height: renderIOSHeight,
              }
        }
      >
        {this.props.children}
      </div>
    );
  }
}

export default ProjectHeroWrapper;



// WEBPACK FOOTER //
// ./src/components/project/project-hero/project-hero-wrapper/index.js